import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { getHomeStats } from "@/lib/homeStats.functions";
import { getCompareFeed } from "@/lib/compareFeed.functions";

const Home = lazy(() => import("@/pages/Home"));

export const Route = createFileRoute("/")({
  head: () => seoHead("/"),
  loader: async () => {
    // Flödet hämtas här så att sektionen finns i server-HTML:en och inte
    // skjuter ner resten av sidan när det laddas på klienten.
    const [stats, feed] = await Promise.all([
      getHomeStats(),
      getCompareFeed().catch(() => ({ items: [] })),
    ]);
    return { stats, feed };
  },
  component: () => <Home />,
});
